var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fragment',[_c('div',{class:{mobile: _vm.mobile},attrs:{"id":"cube"}})])}
var staticRenderFns = []

export { render, staticRenderFns }